var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlightedFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5312 0.114441V3.74034C28.5312 5.32667 27.8397 6.913 26.687 8.27271L18.1573 15.9777V25.9489L11.0108 20.9633V15.9777L2.48105 8.04609C1.09785 6.913 0.40625 5.32667 0.40625 3.74034V0.114441H28.5312Z",
    fill: "#56BFD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightedFilter);
export default __webpack_public_path__ + "static/media/highlighted-filter.2a8bb0a681cb0a1bbbebecbf73bc0069.svg";
export { ForwardRef as ReactComponent };